import { render, staticRenderFns } from "./NoHistoryReportResults.vue?vue&type=template&id=e21b5b10&scoped=true&"
import script from "./NoHistoryReportResults.vue?vue&type=script&lang=js&"
export * from "./NoHistoryReportResults.vue?vue&type=script&lang=js&"
import style0 from "./NoHistoryReportResults.vue?vue&type=style&index=0&id=e21b5b10&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21b5b10",
  null
  
)

export default component.exports